module.exports = {
  server: {
    CORS_SETUP_IS_ENABLE: true,
    SERVER_PORT: 4500,
  },
  client: {
    ENVIRONMENT: `local`,
    API_BASEURL: 'https://localhost:5001/',
    AWS_REGION: 'ap-southeast-2',
    AWS_BUCKET_INPUT: 'parenteque-input-dev',
    AWS_ACCESS_KEY_ID: 'AKIA5QVBVK6IZ3M4JDOP',
    AWS_SECRET_ACCESS_KEY: '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',
    AWS_MEDIA_CONVERT_ENDPOINT:
      'https://z5xjggzna.mediaconvert.ap-southeast-2.amazonaws.com',
  },
}
